import * as React from 'react';
import './PronouncedLabels.css';

export class PronouncedLabels extends React.Component<{}, {}> {
    render() {
        return (
            <div className="pronounced-labels font-subheading">
                <div></div>
                <div className="pronounced-text">
                    <div className="chart-content">Less Pronounced</div>
                    <div className="chart-content">More Pronounced</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/charts/PronouncedLabels.tsx